import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;

  .ant-input-search {
    max-width: 320px !important;
  }
`;

export const FiltersGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;

  > * {
    width: fit-content;
  }

  .ant-select {
    width: fit-content !important;
    height: 32px !important;

    .ant-select-selector {
      background: transparent !important;
      border: 1px solid ${({ theme }) => theme.colors.black4} !important;
      border-radius: 4px !important;
      height: 32px !important;
      padding: 0 8px !important;
      font-family: 'Poppins', sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: ${({ theme }) => theme.colors.black7} !important;

      &:hover {
        border-color: ${({ theme }) => theme.colors.black4} !important;
      }
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      font-family: ${({ theme }) => theme.fontFamily.primary} !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: ${({ theme }) => theme.colors.black7} !important;
    }

    .ant-select-selection-placeholder {
      opacity: 0.6;
    }

    &.ant-select-focused .ant-select-selector {
      box-shadow: none !important;
      border-color: ${({ theme }) => theme.colors.black4} !important;
    }
  }

  .ant-picker {
    width: fit-content !important;
    background: transparent !important;
    border: 1px solid ${({ theme }) => theme.colors.black4} !important;
    border-radius: 4px !important;
    height: 32px !important;
    padding: 0 8px !important;

    &:hover {
      border-color: ${({ theme }) => theme.colors.black4} !important;
    }

    &.ant-picker-focused {
      box-shadow: none !important;
      border-color: ${({ theme }) => theme.colors.black4} !important;
    }

    .ant-picker-input > input {
      font-family: 'Poppins', sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: ${({ theme }) => theme.colors.black7} !important;
    }

    .ant-picker-suffix {
      color: ${({ theme }) => theme.colors.black7} !important;
    }
  }
`;

export const ChipWrapper = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 6px 8px;
  border-radius: 4px;
  border: 1px solid;
  border-color: ${({ theme, $selected }) =>
    $selected ? `${theme.colors.green7}` : `${theme.colors.black4}`};
  background: ${({ theme, $selected }) =>
    $selected ? `${theme.colors.green2}` : 'transparent'} !important;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  height: 32px;
  color: ${({ theme, $selected }) => ($selected ? theme.colors.black7 : 'rgba(0,0,0,0.45)')};
  text-align: center;
  white-space: nowrap;

  &:hover {
    background-color: ${({ theme }) => theme.colors.green1} !important;
  }
`;
